import useOrganizationColors from '../../../hooks/useOrganizationColors';

export default function Button({ type, children, icon, onClick }) {
  const Icon = icon;
  let classes = 'rounded flex items-center p-2 ';

  const colors = useOrganizationColors();

  if (type === 'primary') {
    classes += `bg-[${colors?.primary500}] text-white`;
  } else {
    classes += 'bg-white text-cblack-300 border border-gray-200';
  }

  return (
    <button className={classes} type="button" onClick={onClick}>
      {children}
      {icon && (
        <div className="p-1">
          <Icon />
        </div>
      )}
    </button>
  );
}
